import type { FormSchema } from '@/designer/types/form.types'

/**
 * Platform default is tab when the property is absent (generated forms have no
 * stored schema). One place to read — every entry point must call this.
 */
export function resolveOpenMode(schema: FormSchema | null | undefined): 'tab' | 'modal' {
  const mode = schema?.presentation?.openMode
  return mode === 'modal' ? 'modal' : 'tab'
}
